"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const vue_1 = require("vue");
const vue_2 = require("vue");
const _hoisted_1 = /*#__PURE__*/ (0, vue_2.createElementVNode)("b", null, "marso", -1);
const _hoisted_2 = { class: "app-container" };
const _hoisted_3 = { class: "under-banner" };
const _hoisted_4 = { class: "homepage-text" };
const Banner_vue_1 = __importDefault(require("../../../components/frontend/Banner.vue"));
const Form_1 = require("../../../components/Form");
const CustomButton_vue_1 = __importDefault(require("../../../components/frontend/CustomButton.vue"));
//import { useAppLoginStore } from "../../../stores/appLogin/appLoginStore";
const vue_3 = require("vue");
const vue_router_1 = require("vue-router");
const appLoginStore_1 = require("../../../stores/appLogin/appLoginStore");
exports.default = (0, vue_1.defineComponent)({
    __name: 'Home',
    setup(__props) {
        const appLoginStore = (0, appLoginStore_1.useAppLoginStore)();
        const router = (0, vue_router_1.useRouter)();
        //router.push("/admin"); // átírányít folyamatosan az admin loginra ha ide érkezne be van valaki
        const email = (0, vue_3.ref)("");
        const emailError = (0, vue_3.ref)("");
        const serverError = (0, vue_3.ref)("");
        const valid = (0, vue_3.ref)(true);
        const onEmailInput = (e) => {
            email.value = e.target.value;
        };
        function validateEmail() {
            const expression = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i;
            const result = expression.test(email.value); // true
            if (!result) {
                valid.value = false;
                emailError.value = "Helytelen e-mail cím formátum!";
            }
            else {
                valid.value = true;
                emailError.value = "";
                //appLoginStore.setNewUser(email.value, router);
                appLoginStore
                    .setNewAppUser(email.value, router)
                    .catch((error) => {
                    serverError.value = error.toString();
                });
            }
        }
        return (_ctx, _cache) => {
            return ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)(vue_2.Fragment, null, [
                (0, vue_2.createVNode)(Banner_vue_1.default, { "background-image": "frontend/home_banner.png" }, {
                    bannerText: (0, vue_2.withCtx)(() => [
                        (0, vue_2.createTextVNode)(" CLICK'N'FIt ")
                    ]),
                    bottomText: (0, vue_2.withCtx)(() => [
                        (0, vue_2.createTextVNode)(" powered by "),
                        _hoisted_1
                    ]),
                    _: 1
                }),
                (0, vue_2.createElementVNode)("div", _hoisted_2, [
                    (0, vue_2.createElementVNode)("div", _hoisted_3, [
                        (0, vue_2.createVNode)((0, vue_2.unref)(Form_1.ShopInput), {
                            modelValue: email.value,
                            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((email).value = $event)),
                            "invalid-message": emailError.value,
                            label: _ctx.$trans('Email_address', 'Email address', 'frontend_home'),
                            name: "email",
                            "show-validity": true,
                            valid: valid.value,
                            "max-length": 320,
                            onInput: onEmailInput
                        }, null, 8, ["modelValue", "invalid-message", "label", "valid"]),
                        (0, vue_2.createVNode)(CustomButton_vue_1.default, {
                            type: "red",
                            class: "button-top-margin",
                            onPressed: _cache[1] || (_cache[1] = ($event) => (validateEmail()))
                        }, {
                            default: (0, vue_2.withCtx)(() => [
                                (0, vue_2.createTextVNode)((0, vue_2.toDisplayString)(_ctx.$trans("next", "Next", "frontend_home")), 1)
                            ]),
                            _: 1
                        })
                    ]),
                    (0, vue_2.createElementVNode)("div", _hoisted_4, (0, vue_2.toDisplayString)(_ctx.$trans("home_text", 
                    // eslint-disable-next-line max-len
                    "Foglalja le egyszerűen és könnyedén online az időpontját szervizünkbe, mindössze néhány kattintással! Csupán néhány információ megadásával biztosíthatja magának a kívánt szervizidőpontot. Az egész folyamat gyors és felhasználóbarát, így Ön több időt tölthet a fontos dolgokkal, miközben mi gondoskodunk járműve karbantartásáról.", "frontend_home")), 1)
                ])
            ], 64));
        };
    }
});
